import {useMemo, useState} from "preact/compat";
import {SURVEY_DATA} from "./content.data";
import {useEffect} from "preact/hooks";
import {api} from "../../../services";

// Memo to compute all the available steps
const STEPS_AMOUNT = 5;

export const useContent = (props) => {
    // Destructured props
    const {handleExpandAction} = props;

    // State to control the current survey's step
    const [currentStep, setCurrentStep] = useState(1);
    // State to store all user's answers
    const [payload, setPayload] = useState([]);
    // State to control the alert that says that there are only 2 steps left
    const [showAlert, setShowAlert] = useState(false);

    // Memo to store all the survey data from all steps
    const surveyData = useMemo(() => {
        return SURVEY_DATA;
    }, []);

    // A workaround to deal with the mid-survey alert flicking issue
    const hasSynchronizedThirdStep = useMemo(() => {
        return payload.some(stepData => {
            return stepData?.question_text?.toLowerCase().includes("você encontrou tudo que precisava?");
        });
    }, [payload]);

    // Procedure to update the "answers" data object
    const handlePayloadUpdate = (props) => {
        // Destructured props
        const {
            data = null
        } = props;

        if (!data) {
            return;
        }

        setPayload(prevState => {
            return [
                ...prevState,
                data
            ]
        })
    }

    // Special logic to display an alert
    // that says that there are only 2 steps left
    const handleAlert = () => {
        setShowAlert(true);

        // Sets a timer to deactivate the alert
        // and come back to the standard flow after two seconds
        const timer = setTimeout(() => {
            setCurrentStep(prevState => prevState + 1);

            setShowAlert(false);

            clearTimeout(timer);
        }, 2000);
    }

    // Procedure to post all the form data to the backend
    const postForm = async () => {
        try {
            let response = api.post("/v1/feedbackSale", {
                questions: [...payload]
            })

            // console.log(response);
        } catch (e) {
            console.error(e);
        }
    }

    // Procedure to handle the survey's step change
    const handleStepChange = async (props) => {
        // Destructured props
        const {action} = props;

        // Handles the targeted logic
        switch (action.toUpperCase()) {
            case "NEXT":
                // Special logic for the alert
                if (currentStep === 3) {
                    handleAlert();

                    return;
                }

                setCurrentStep(prevState => prevState + 1);

                break;
            // Just in case we need to implement a feature to step back on the form
            case "PREV":
                setCurrentStep(prevState => prevState - 1);

                break;
            default:
                return;
        }
    }

    // Effect to both expand and narrow the whole modal
    useEffect(() => {
        handleExpandAction({
            action: (
                currentStep > 1 &&
                currentStep < STEPS_AMOUNT + 1
            ) ? "EXPAND" : "NARROW"
        })
    }, [currentStep]);

    // Effect to trigger the form-post procedure
    useEffect(() => {
        // console.log("FORM PAYLOAD", payload);

        if (payload.length === 4) {
            postForm().then();
        }
    }, [payload]);

    return {
        // Data
        currentStep,
        surveyData,
        STEPS_AMOUNT,
        showAlert,
        hasSynchronizedThirdStep,
        // Methods | Procedures
        handlePayloadUpdate,
        handleStepChange
    }
}
